<template>
  <div class="custom-field-option">
    <div
      v-for="option in opportunityCustomFieldOption"
      :key="option.id"
      class="option-item"
    >
      <BEditableContent
        :value="option.name"
        required
        :editing="isEditing(option)"
        @update:editing="updateEditing($event, option)"
        @check="updateOpportunityCustomFieldOptionLabel($event, option)"
      />
      <BBtn text>
        <BIcon
          class="px-200"
          size="small"
          type="gray"
          @click="() => deleteOpportunityCustomFieldOption(option)"
        >
          close
        </BIcon>
      </BBtn>
    </div>
    <BInputBox
      v-if="isOpenOptionInput"
      v-model="newOption"
      horiz
      required
      :loading="loading"
      @check="appendOption"
      @close="closeOptionInput"
    />
    <BBtn
      type="primary"
      text
      size="small"
      @click="openOptionInput"
    >
      <span class="append-option">{{ $t('general.append.of', {item: $t('general.option')}) }}</span>
    </BBtn>
  </div>
</template>

<script>
import lodash from 'lodash';
import { mapWaitingActions } from 'vue-wait';
import { useErrorHandler } from '@/composable/error-handler';

export default {
  props: {
    opportunityCustomFieldOption: Array,
    opportunityCustomFieldId: Number,
    opportunityCustomFieldName: String,
    loading: Boolean,
  },
  emits: ['delete'],
  setup() {
    const { defaultHandler } = useErrorHandler();
    return {
      defaultHandler,
    };
  },
  data () {
    return this.initialState();
  },
  methods: {
    ...mapWaitingActions('user', {
      updateOpportunityCustomFieldAction: 'updateOpportunityCustomFieldWait',
      deleteOpportunityCustomFieldOptionAction: 'deleteOpportunityCustomFieldOptionWait',
    }),
    initialState () {
      return {
        isOpenOptionInput: false,
        newOption: '',
        editingOptionId: null,
      };
    },
    initialize () {
      Object.assign(this.$data, this.initialState());
    },
    openOptionInput () {
      this.isOpenOptionInput = true;
    },
    closeOptionInput () {
      this.initialize();
    },
    async appendOption () {
      const options = [
        ...lodash.cloneDeep(this.opportunityCustomFieldOption),
        { name: this.newOption },
      ];
      await this.updateOpportunityCustomFieldOption(options);
      this.initialize();
    },
    updateEditing (editing, option) {
      this.editingOptionId = editing ? option.id : null;
    },
    isEditing (option) {
      return this.editingOptionId === option.id;
    },
    async updateOpportunityCustomFieldOptionLabel (newOptionLabel, currentOption) {
      const options = lodash.cloneDeep(this.opportunityCustomFieldOption).map(option => {
        if (option.id === currentOption.id) option.name = newOptionLabel;
        return option;
      });
      await this.updateOpportunityCustomFieldOption(options);
      this.initialize();
    },
    async updateOpportunityCustomFieldOption (options) {
      await this.updateOpportunityCustomFieldAction({
        opportunityCustomFieldId: this.opportunityCustomFieldId,
        body: { opportunityCustomField: { options } },
        errorHandlers: {
          422: this.defaultHandler,
        },
      });
    },
    async deleteOpportunityCustomFieldOption (option) {
      const check = await this.$bitterAlert.show({
        title: `「 ${option.name} 」${this.$t('general.delete.message')}`,
        text: this.$t('opportunityCustomField.option.deleteMessage', { item: this.opportunityCustomFieldName }),
      });
      if (!check) return;
      await this.deleteOpportunityCustomFieldOptionAction({
        opportunityCustomFieldOptionId: option.id,
      });
      this.$emit('delete');
    },
  },
};
</script>

<style lang="scss" scoped>
  .custom-field-option {
    width: 420px;
    margin-left: 60px;
  }

  .option-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid $bdcolor-light;
    line-height: 36px;
    font-size: $fontsize-100;
  }

  .append-option {
    color: $basecolor-primary;
  }
</style>
